exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".parent[data-v-752eba09]{width:95%;height:500px;background-color:rgba(0,128,0,.1);-ms-flex-item-align:center;align-self:center}.p41[data-v-752eba09]{white-space:nowrap;overflow:scroll}", ""]);

// exports
